import { AppToasterV2 } from "@ucl/library";
import { FinancialApplicationCoreData, FinancialApplication } from "@/types";
import { useAuthenticatedApiClient } from "./useAuthenticatedApiClient";
import FinancialApplicationApiClient from "@/api/financialApplicationApiClient";

interface BankerFinancialApplicationModule {
  createFinancialApplicationAsBanker: () => Promise<FinancialApplicationCoreData | undefined>;
  createSeedFinancialApplication: () => Promise<FinancialApplication | undefined>;
}

export const useBankerFinancialApplication = (): BankerFinancialApplicationModule => {
  const financialApplicationApiClient = useAuthenticatedApiClient(FinancialApplicationApiClient);

  const createFinancialApplicationAsBanker = async () => {
    try {
      const response = await financialApplicationApiClient.createFinancialApplicationAsBanker();
      return response;
    } catch (err) {
      console.error("createFinancialApplicationAsBanker - error:", err);
      AppToasterV2.showFailedActionToaster("Failed to initialize financial application");
    }
  };

  const createSeedFinancialApplication = async () => {
    try {
      const response = await financialApplicationApiClient.createSeedFinancialApplication();
      return response;
    } catch (err) {
      console.error("createSeedFinancialApplication - error:", err);
      AppToasterV2.showFailedActionToaster("Failed to create seed financial application");
    }
  };

  return {
    createFinancialApplicationAsBanker,
    createSeedFinancialApplication,
  };
};
